"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var Currency;
(function (Currency) {
    let DisplayFormat;
    (function (DisplayFormat) {
        DisplayFormat["Symbol"] = "symbol";
        DisplayFormat["Name"] = "name";
    })(DisplayFormat = Currency.DisplayFormat || (Currency.DisplayFormat = {}));
    let Code;
    (function (Code) {
        Code["AFN"] = "AFN";
        Code["EUR"] = "EUR";
        Code["ALL"] = "ALL";
        Code["DZD"] = "DZD";
        Code["USD"] = "USD";
        Code["AOA"] = "AOA";
        Code["XCD"] = "XCD";
        Code["ARS"] = "ARS";
        Code["AMD"] = "AMD";
        Code["AWG"] = "AWG";
        Code["AUD"] = "AUD";
        Code["AZN"] = "AZN";
        Code["BSD"] = "BSD";
        Code["BHD"] = "BHD";
        Code["BDT"] = "BDT";
        Code["BBD"] = "BBD";
        Code["BYN"] = "BYN";
        Code["BZD"] = "BZD";
        Code["XOF"] = "XOF";
        Code["BMD"] = "BMD";
        Code["INR"] = "INR";
        Code["BTN"] = "BTN";
        Code["BOB"] = "BOB";
        Code["BOV"] = "BOV";
        Code["BAM"] = "BAM";
        Code["BWP"] = "BWP";
        Code["NOK"] = "NOK";
        Code["BRL"] = "BRL";
        Code["BND"] = "BND";
        Code["BGN"] = "BGN";
        Code["BIF"] = "BIF";
        Code["CVE"] = "CVE";
        Code["KHR"] = "KHR";
        Code["XAF"] = "XAF";
        Code["CAD"] = "CAD";
        Code["KYD"] = "KYD";
        Code["CLP"] = "CLP";
        Code["CLF"] = "CLF";
        Code["CNY"] = "CNY";
        Code["COP"] = "COP";
        Code["COU"] = "COU";
        Code["KMF"] = "KMF";
        Code["CDF"] = "CDF";
        Code["NZD"] = "NZD";
        Code["CRC"] = "CRC";
        Code["HRK"] = "HRK";
        Code["CUP"] = "CUP";
        Code["CUC"] = "CUC";
        Code["ANG"] = "ANG";
        Code["CZK"] = "CZK";
        Code["DKK"] = "DKK";
        Code["DJF"] = "DJF";
        Code["DOP"] = "DOP";
        Code["EGP"] = "EGP";
        Code["SVC"] = "SVC";
        Code["ERN"] = "ERN";
        Code["ETB"] = "ETB";
        Code["FKP"] = "FKP";
        Code["FJD"] = "FJD";
        Code["XPF"] = "XPF";
        Code["GMD"] = "GMD";
        Code["GEL"] = "GEL";
        Code["GHS"] = "GHS";
        Code["GIP"] = "GIP";
        Code["GTQ"] = "GTQ";
        Code["GBP"] = "GBP";
        Code["GNF"] = "GNF";
        Code["GYD"] = "GYD";
        Code["HTG"] = "HTG";
        Code["HNL"] = "HNL";
        Code["HKD"] = "HKD";
        Code["HUF"] = "HUF";
        Code["ISK"] = "ISK";
        Code["IDR"] = "IDR";
        Code["XDR"] = "XDR";
        Code["IRR"] = "IRR";
        Code["IQD"] = "IQD";
        Code["ILS"] = "ILS";
        Code["JMD"] = "JMD";
        Code["JPY"] = "JPY";
        Code["JOD"] = "JOD";
        Code["KZT"] = "KZT";
        Code["KES"] = "KES";
        Code["KPW"] = "KPW";
        Code["KRW"] = "KRW";
        Code["KWD"] = "KWD";
        Code["KGS"] = "KGS";
        Code["LAK"] = "LAK";
        Code["LBP"] = "LBP";
        Code["LSL"] = "LSL";
        Code["ZAR"] = "ZAR";
        Code["LRD"] = "LRD";
        Code["LYD"] = "LYD";
        Code["CHF"] = "CHF";
        Code["MOP"] = "MOP";
        Code["MKD"] = "MKD";
        Code["MGA"] = "MGA";
        Code["MWK"] = "MWK";
        Code["MYR"] = "MYR";
        Code["MVR"] = "MVR";
        Code["MRU"] = "MRU";
        Code["MUR"] = "MUR";
        Code["XUA"] = "XUA";
        Code["MXN"] = "MXN";
        Code["MXV"] = "MXV";
        Code["MDL"] = "MDL";
        Code["MNT"] = "MNT";
        Code["MAD"] = "MAD";
        Code["MZN"] = "MZN";
        Code["MMK"] = "MMK";
        Code["NAD"] = "NAD";
        Code["NPR"] = "NPR";
        Code["NIO"] = "NIO";
        Code["NGN"] = "NGN";
        Code["OMR"] = "OMR";
        Code["PKR"] = "PKR";
        Code["PAB"] = "PAB";
        Code["PGK"] = "PGK";
        Code["PYG"] = "PYG";
        Code["PEN"] = "PEN";
        Code["PHP"] = "PHP";
        Code["PLN"] = "PLN";
        Code["QAR"] = "QAR";
        Code["RON"] = "RON";
        Code["RUB"] = "RUB";
        Code["RWF"] = "RWF";
        Code["SHP"] = "SHP";
        Code["WST"] = "WST";
        Code["STN"] = "STN";
        Code["SAR"] = "SAR";
        Code["RSD"] = "RSD";
        Code["SCR"] = "SCR";
        Code["SLL"] = "SLL";
        Code["SGD"] = "SGD";
        Code["XSU"] = "XSU";
        Code["SBD"] = "SBD";
        Code["SOS"] = "SOS";
        Code["SSP"] = "SSP";
        Code["LKR"] = "LKR";
        Code["SDG"] = "SDG";
        Code["SRD"] = "SRD";
        Code["SZL"] = "SZL";
        Code["SEK"] = "SEK";
        Code["CHE"] = "CHE";
        Code["CHW"] = "CHW";
        Code["SYP"] = "SYP";
        Code["TWD"] = "TWD";
        Code["TJS"] = "TJS";
        Code["TZS"] = "TZS";
        Code["THB"] = "THB";
        Code["TOP"] = "TOP";
        Code["TTD"] = "TTD";
        Code["TND"] = "TND";
        Code["TRY"] = "TRY";
        Code["TMT"] = "TMT";
        Code["UGX"] = "UGX";
        Code["UAH"] = "UAH";
        Code["AED"] = "AED";
        Code["USN"] = "USN";
        Code["UYU"] = "UYU";
        Code["UYI"] = "UYI";
        Code["UYW"] = "UYW";
        Code["UZS"] = "UZS";
        Code["VUV"] = "VUV";
        Code["VES"] = "VES";
        Code["VND"] = "VND";
        Code["YER"] = "YER";
        Code["ZMW"] = "ZMW";
        Code["ZWL"] = "ZWL";
        Code["XBA"] = "XBA";
        Code["XBB"] = "XBB";
        Code["XBC"] = "XBC";
        Code["XBD"] = "XBD";
        Code["XTS"] = "XTS";
        Code["XXX"] = "XXX";
        Code["XAU"] = "XAU";
        Code["XPD"] = "XPD";
        Code["XPT"] = "XPT";
        Code["XAG"] = "XAG";
    })(Code = Currency.Code || (Currency.Code = {}));
})(Currency = exports.Currency || (exports.Currency = {}));
//# sourceMappingURL=Currency.js.map